import { type ISortOptionSchema } from '@/repositories/generated/shared/search-offers/entities/sorting_properties/SortOptionSchema';
import type { TGetOffersByPinResponse_1 } from '@/repositories/generated/shared/search-offers/v1/get-offers-by-pin';

export function sortOptionsFromGetOffersByPinSelector(state: TGetOffersByPinResponse_1): ISortOptionSchema[] {
  return state.sortingProperties.sortOptions;
}
